import { useSearchParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { CircularProgress, Box } from '@mui/material';
import CombinedReportViewer from '../../CombinedReportViewer';

export default function SharedCombinedReport() {
  const [searchParams] = useSearchParams();
  const [groupData, setGroupData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openModal, setOpenModal] = useState(true);

  useEffect(() => {
    fetchGroupData();
  }, []);

  const fetchGroupData = async () => {
    try {
      const reportIDs = searchParams.get('reportIDs');
      if (!reportIDs) {
        setError('No report IDs provided');
        setLoading(false);
        return;
      }

      const reportIDArray = reportIDs.split(',');
      const fetchedReports = [];

      for (const reportID of reportIDArray) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_NODE_URL}/record/${reportID}`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
              },
            },
          );

          if (response.ok) {
            const report = await response.json();
            fetchedReports.push(report);
          } else {
            console.warn(`Failed to fetch report ${reportID}`);
          }
        } catch (error) {
          console.error(`Error fetching report ${reportID}:`, error);
        }
      }

      if (fetchedReports.length > 0) {
        // Create a group object similar to what CombinedReportViewer expects
        const group = {
          reports: fetchedReports,
          chatID: fetchedReports[0]?.chatID,
        };
        setGroupData(group);
      } else {
        setError('No reports found');
      }
    } catch (error) {
      console.error('Error fetching shared reports:', error);
      setError('Failed to load shared reports');
    } finally {
      setLoading(false);
    }
  };

  const closeViewer = () => {
    setOpenModal(false);
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <h2 style={{ color: '#ef4444', margin: 0 }}>Error</h2>
        <p style={{ color: '#6b7280', margin: 0 }}>{error}</p>
        <p style={{ color: '#6b7280', margin: 0 }}>
          The shared combined report may have been removed or is no longer
          available.
        </p>
      </Box>
    );
  }

  if (!groupData || groupData.reports.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <h2 style={{ color: '#6b7280', margin: 0 }}>No reports found</h2>
        <p style={{ color: '#6b7280', margin: 0 }}>
          The shared combined report may have been removed or is no longer
          available.
        </p>
      </Box>
    );
  }

  return (
    <div>
      <CombinedReportViewer
        open={openModal}
        setOpen={setOpenModal}
        groupData={groupData}
        viewerState={closeViewer}
        publicView={true}
      />
    </div>
  );
}
